import React, { Component } from "react";
import Table from "react-bootstrap/Table";
import { PrimarySecondaryString } from '../../../../../../../constants/external-constants';
import { convertToDate, toYesOrNo } from '../../../../../../../utils/helpers.utils';
import { OrderRequestFiles } from "../../../request-details-files.component";
import { RequestOnBehalfDetails } from "../../../request-on-behalf-details.component"
import Translation from "../../../../../../common/translation/translation.component";

export class NewCircuitDetails extends Component {
    constructor(props) {
        super(props);
    }


    handleShow = () => {
        this.setState({
            show: true
        });
    }

    render() {
        const { data } = this.props;
        return (
            <div>                
                <h4 className="order-detail-title"><Translation translationKey="order_request_details" /></h4>
                <div className="order-detail-location">
                    <RequestOnBehalfDetails robDetails={data.RequestedInBeHalfOf} isRob={data.Order.IsRequestedInBehalf} />
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="order_number" /></td>
                                <td>{data.Order.OrderNumber}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title"><Translation translationKey="capital_location" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="country" /></td>
                                <td>{data.Location.CountryName}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="billing_address" /></td>
                                <td>{data.Location.DeliveryAddress}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="location_address" /></td>
                                <td>{data.LocationAddress != null ? data.LocationAddress.LocationName : null}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="demarc_location_1" /></td>
                                <td>{data.DemarcLocation}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="location_address_p2p" /></td>
                                <td>{data.LocationP2P != null ? data.LocationP2P.LocationName : null}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="demarc_location_2" /></td>
                                <td>{data.DemarcLocationPTP}</td>
                            </tr>
                            {
                                //<tr>
                                //    <td>Company Code</td>
                                //    <td>{data.Order.CostCenter}</td>
                                //</tr>
                            }
                            <tr>
                                <td><Translation translationKey="gl_code" /></td>
                                <td>{data?.BusinessWireline?.CircuitCostAllocations?.GLCode}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="cost_center" /></td>
                                <td>{data?.BusinessWireline?.CircuitCostAllocations?.CostCode}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title"><Translation translationKey="capital_pos" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="vendor" /></td>
                                <td>{data.Subscription.Vendor}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="category" /></td>
                                <td>{data.Subscription.ItemUse}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="circuit_type" /></td>
                                <td>{data.Circuit.CircuitTypeName}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="sub_circuit_type" /></td>
                                <td>{data.Subscription.SubCircuitType}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="primary_secondary" /></td>
                                <td>{data.Subscription.PrimarySecondary}</td>
                            </tr>
                            {data.Subscription.PrimarySecondary.toLowerCase() == PrimarySecondaryString.secondary && data.Subscription.PrimarySecondary.toLowerCase() != PrimarySecondaryString.both &&

                                <tr>
                                    <td><Translation translationKey="btn" /></td>
                                    <td>{data.Subscription.BtnText}</td>
                                </tr>
                            }
                            <tr>
                                <td><Translation translationKey="mrc" /></td>
                                <td>{data.Subscription.Mrc}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="nrc" /></td>
                                <td>{data.Subscription.Nrc}</td>
                            </tr>

                            {data.Subscription.PrimarySecondary.toLowerCase() == PrimarySecondaryString.both &&

                                <tr>
                                    <td><Translation translationKey="mrc2" /></td>
                                    <td>{data.Subscription.Mrc2}</td>
                                </tr>
                            }
                            {data.Subscription.PrimarySecondary.toLowerCase() == PrimarySecondaryString.both &&
                                <tr>
                                    <td><Translation translationKey="nrc2" /></td>
                                    <td>{data.Subscription.Nrc2}</td>
                                </tr>
                            }
                            {data.Subscription.PrimarySecondary.toLowerCase() &&
                                <tr>
                                    <td><Translation translationKey="capital_total_cost" /></td>
                                    <td>{data.Subscription.Mrc + data.Subscription.Nrc + data.Subscription.Mrc2 + data.Subscription.Nrc2}</td>
                                </tr>
                            }
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title">
                        <Translation translationKey="capital_business_justification" />
                    </h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="approver" /></td>
                                <td>{data.BusinessWireline.WirelineApproverName}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="local_contact_email_address" /></td>
                                <td>{data.BusinessWireline.LocalContactEmail}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="local_contact_fullname" /></td>
                                <td>{data.BusinessWireline.LocalContactFullName}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="local_contact_phone_number" /></td>
                                <td>{data.BusinessWireline.LocalContactPhone}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="alt_local_contact_email_address" /></td>
                                <td>{data.BusinessWireline.AltLocalContactEmail}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="alt_local_contact_full_name" /></td>
                                <td>{data.BusinessWireline.AltLocalContactFullName}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="alt_local_contact_phone_number" /></td>
                                <td>{data.BusinessWireline.AltLocalContactPhone}</td>
                            </tr>

                            <tr>
                                <td><Translation translationKey="need_by_date" /></td>
                                <td>{convertToDate(data.Order.NeedByDate, 'DD MMM YYYY')}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="purpose_of_use" /></td>
                                <td>{data.BusinessJustification.PurposeOfUse}</td>
                            </tr>   
                            <tr>
                                <td><Translation translationKey="expedite_request" /></td>
                                <td>{toYesOrNo(data.BusinessWireline.ExpediteRequest)}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="business_justification" /></td>
                                <td>{data.BusinessJustification.BusinessJustification}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="additional_information" /></td>
                                <td>{data.BusinessJustification.AdditionalInformation}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <OrderRequestFiles files={data.Order.OrderFileNames} />
                </div>
            </div>
        );
    }
}